export enum PiccDetectEnum {
  None = '',
  Detected = 'detected',
  Detecting = 'detecting'
}
